import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Resume.css";

const Resume = (props) => {
  /* STATES */
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreens(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  /* REUSABLE MINOR COMPONENTS */
  const ResumeHeading = (props) => {
    return (
      <div className="resume-heading">
        <div className="resume-main-heading">
          <div className="heading-bullet"></div>
          <span>
            {props.heading ? (
              props.link ? (
                <a className="projectLinks" href={props.link}>
                  {props.heading} (Link)
                </a>
              ) : (
                props.heading
              )
            ) : (
              ""
            )}
          </span>
          {props.fromDate ? (
  <div className="heading-date">
    {props.toDate ? `${props.fromDate}-${props.toDate}` : props.fromDate}
  </div>
) : null}

        </div>
        <div className="resume-sub-heading">
          <span>{props.subHeading ? props.subHeading : ""}</span>
        </div>
        <div className="resume-heading-description">
          <span>{props.description ? props.description : ""}</span>
        </div>
      </div>
    );
  };

  /* STATIC RESUME DATA FOR THE LABELS*/
  const resumeBullets = [
    { label: "Education", logoSrc: "education.svg" },
    { label: "Experience", logoSrc: "work-history.svg" },
    { label: "Achievements", logoSrc: "interests.svg" },
  ];

  const resumeDetails = [
    /* EDUCATION */
    <div 
      className={`resume-screen-container ${selectedBulletIndex === 0 ? 'active' : ''}`}
      key="education"
    >
      <ResumeHeading
        heading={"Indira Gandhi Delhi Technical University for Women"}
        subHeading={
          <>
            Bachelor of Technology in Computer Science and Artificial Intelligence
            <br/>
            <span className="orange-text">CGPA: 9.58</span>
          </>
        }
        fromDate={"2024"}
        toDate={"Present"}
      />

      <ResumeHeading
        heading={"DL.D.A.V. Model School"}
        subHeading={
          <>
            Class XII
            <br />
            <span className="orange-text">Percentage: 94.2%</span>
          </>
        }
        fromDate={"2024"}
      />
    </div>,

/* WORK EXPERIENCE */
<div 
  className={`resume-screen-container ${selectedBulletIndex === 1 ? 'active' : ''}`}
  key="work-experience"
>
  <div className="experience-container">
    <ResumeHeading
      heading={"Google"}
      subHeading={"Incoming Software Engineer, Site Reliability Engineering Intern"}
      fromDate={"Summer 2027"}
    />
    <ResumeHeading
      heading={"ISEA Phase-III, MeitY, Govt. of India"}
      subHeading={"Digital Forensics Intern"}
      fromDate={"May 2025"}
      toDate={"July 2025"}
    />
    <div className="experience-description">
      <span className="resume-description-text">
        During my internship under the ISEA Phase-III program, I developed{" "}
        <span className="orange-text">Blue Guard</span>, a real-time <span className="orange-text">SIEM </span>
        tool for <span className="orange-text">Apache and Nginx web servers</span> that secured{" "}
        <span className="orange-text">3rd position in Project Development</span>.
      </span>
      <span className="resume-description-text">
        Blue Guard features a hybrid detection engine combining a 21-day
        rolling rule-based baseline with Isolation Forest–based anomaly
        detection, achieving near real-time threat identification with{" "}
        <span className="orange-text">~180–200 ms detection latency</span>.
      </span>
      <span className="resume-description-text">
        I built the end-to-end pipeline, including Python agents, Flask APIs,
        feature engineering, GeoIP enrichment, SQLite-backed analytics,
        instant Slack/email alerts, and an interactive Streamlit dashboard
        for live monitoring and downloadable forensic reports.
      </span>
      
      {/* GitHub link for Blue Guard - Removed border and reduced spacing */}
      <div style={{ 
        marginTop: "5px",  /* Reduced from 15px to 5px */
        width: "100%"
      }}>
        <a
          href="https://github.com/AashiJain971/Blue_Guard"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1e90ff",
            fontSize: "12px",
            fontFamily: "Poppins SemiBold",
            textDecoration: "none",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            wordWrap: "break-word"
          }}
        >
          {/* GitHub SVG Icon */}
          <svg 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="currentColor"
            style={{ flexShrink: 0 }}
          >
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
          </svg>
          BlueGuard
        </a>
      </div>
    </div>
  </div>
</div>,
    /* ACHIEVEMENTS */
    <div
      className={`resume-screen-container ${selectedBulletIndex === 2 ? "active" : ""}`}
      key="achievements"
    >
      <div className="achievement-list">
        <div className="achievement-item">
          <div className="achievement-bullet">●</div>
          <div className="achievement-content">
            <span className="achievement-text">
              <strong className="achievement-highlight">Solved 1200+ DSA problems</strong>, strengthening problem-solving and algorithmic skills. {" "}
              <a
                href="https://codolio.com/profile/aashijain971"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1e90ff", textDecoration: "none" }}
              >
                [Codolio]
              </a>
            </span>
          </div>
        </div>

        <div className="achievement-item">
          <div className="achievement-bullet">●</div>
          <div className="achievement-content">
            <span className="achievement-text">
             <strong className="achievement-highlight">Selected for GDC I-NITIATE 2026 bootcamp at IIT Madras as a team lead</strong>.
            </span>
          </div>
        </div>

        <div className="achievement-item">
          <div className="achievement-bullet">●</div>
          <div className="achievement-content">
            <span className="achievement-text">
              <span style={{ color: "#ff5823", fontFamily: "Poppins SemiBold", fontWeight: 700 }}> National Finalist at Blueprint 2026, IIT Delhi</span> among <span style={{ color: "#ff5823", fontFamily: "Poppins SemiBold", fontWeight: 700 }}>1000+ teams</span>.
            </span>
          </div>
        </div>

        <div className="achievement-item">
          <div className="achievement-bullet">●</div>
          <div className="achievement-content">
            <span className="achievement-text">
              Recognised as a <span style={{ color: "#ff5823", fontFamily: "Poppins SemiBold", fontWeight: 700 }}>Top 60 student founder</span> at the <span style={{ color: "#ff5823", fontFamily: "Poppins SemiBold", fontWeight: 700 }}>Delhi Startup Yuva Festival 2026</span>, 
              organised by DTTE & TiE Delhi-NCR, among <span style={{ color: "#ff5823", fontFamily: "Poppins SemiBold", fontWeight: 700 }}>750+ startups</span> across Delhi; received a <span style={{ color: "#ff5823", fontFamily: "Poppins SemiBold", fontWeight: 700 }}>₹1 lakh prize</span> from <span style={{ color: "#ff5823", fontFamily: "Poppins SemiBold", fontWeight: 700 }}>Delhi Government dignitaries</span>.
            </span>
          </div>
        </div>

        <div className="achievement-item">
          <div className="achievement-bullet">●</div>
          <div className="achievement-content">
            <span className="achievement-text">
               <span style={{ color: "#ff5823", fontFamily: "Poppins SemiBold", fontWeight: 700 }}>Led team NextGen_Coders</span> to win <span style={{ color: "#ff5823", fontFamily: "Poppins SemiBold", fontWeight: 700 }}>Industrial Ideathon 2025</span>, organised by the Department of Industries, GNCTD & DSIIDC in partnership with NSUT; secured a <span style={{ color: "#ff5823", fontFamily: "Poppins SemiBold", fontWeight: 700 }}>₹5 lakh prize awarded by Delhi CM Smt. Rekha Gupta</span>.
            </span>
          </div>
        </div>

        <div className="achievement-item">
          <div className="achievement-bullet">●</div>
          <div className="achievement-content">
            <span className="achievement-text">
              Secured <strong className="achievement-highlight">Top 20</strong> in <strong className="achievement-highlight">Innov8 3.0 – AI & Innovation Challenge</strong> (Eightfold.ai & IIT Delhi, 2025), <strong className="achievement-highlight">Top 10</strong> in <strong className="achievement-highlight">Blueprint 2025, IIT Delhi</strong> among <strong className="achievement-highlight">1500+ teams</strong>, <strong className="achievement-highlight">Top 148</strong> in <strong className="achievement-highlight">Smart Delhi Ideathon 2025</strong> among <strong className="achievement-highlight">1000+ teams</strong>, including <strong className="achievement-highlight">Top 30 in track</strong>, and <strong className="achievement-highlight">2nd position</strong> in <strong className="achievement-highlight">SHARK TANKS IGDTUW 2025</strong>.
            </span>
          </div>
        </div>

        <div className="achievement-item">
          <div className="achievement-bullet">●</div>
          <div className="achievement-content">
            <span className="achievement-text">
              <strong className="achievement-highlight">Felicitated by IGDTUW</strong> for yearly achievements in hackathons and innovation programs.
            </span>
          </div>
        </div>

        <div className="achievement-item">
          <div className="achievement-bullet">●</div>
          <div className="achievement-content">
            <span className="achievement-text">
              <strong className="achievement-highlight">JEE Advanced 2024</strong> qualified student. {" "}
              <a
                href="https://drive.google.com/drive/u/0/folders/1qYchNaNEaVh6BV5sET63VANSEKuZY9tJ"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1e90ff", textDecoration: "none" }}
              >
                [View All Certificates]
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  ];

  const handleCarousal = (index) => {
    setSelectedBulletIndex(index);
  };

  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className={
          index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
        }
        key={index}
      >
        <img
          className="bullet-logo"
          src={require(`../../assets/Resume/${bullet.logoSrc}`).default}
          alt="B"
        />
        <span className="bullet-label">{bullet.label}</span>
      </div>
    ));
  };

  const getResumeScreens = () => {
    return (
      <div className="resume-details-carousal">
        {resumeDetails.map((ResumeDetail, index) => (
          <div key={index}>
            {ResumeDetail}
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    return () => {
      /* UNSUBSCRIBE THE SUBSCRIPTIONS */
      fadeInSubscription.unsubscribe();
    };
  }, [fadeInSubscription]);

  return (
    <div
      className="resume-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="resume-content">
        <ScreenHeading title={"Accomplishments"} subHeading={"My background"} />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              <div className="bullet-icons"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>

          <div className="resume-bullet-details">{getResumeScreens()}</div>
        </div>
      </div>
    </div>
  );
};

export default Resume;